<template>
  <img src="/logo.svg" alt="Listenarr" class="brand-logo" />
</template>

<script setup lang="ts">
// Presentational brand logo — kept intentionally minimal so it can be
// reused across header, login, and other small UI pieces.
</script>
